import styled from "@emotion/styled";
import { Colors, Fonts, Spacing } from "@snapchat/snap-design-system";

export const EmptyTitle = styled.h1`
    ${Fonts.Heading.H400};
    margin-bottom: ${Spacing["1XS"]}px;
`;

export const EmptyParagraph = styled.p`
    ${Fonts.Paragraph.P200}
    max-width: 800px;
    margin-bottom: ${Spacing.SM}px;
    color: ${Colors.Gray.V300};
`;

export const Body = styled.p`
    ${Fonts.Paragraph.P100}
    max-width: 800px;
    margin-bottom: ${Spacing.SM}px;
`;

export const Disclaimer = styled.p`
    ${Fonts.Paragraph.P200}
    max-width: 800px;
    margin-bottom: ${Spacing.XL}px;
    color: ${Colors.Gray.V300};
`;
export const ButtonWrapper = styled.div`
    margin-bottom: ${Spacing.XL}px;
`;

export const EmptyHostedLensSvg = styled.img`
    width: 300px;
`;
